import { createIconComponent } from '../../factory/create-icon-component';
export const SendEmailIcon = createIconComponent(
  'SendEmailIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 5.01106V13M21 5.01106C21 3.90003 19.9931 3 18.7525 3H4.24746C3.00582 3 2 3.90103 2 5.01206C2 5.67808 2.36992 6.3021 2.98682 6.67611L8.97259 10.3062C10.4981 11.2313 12.5008 11.2313 14.0263 10.3062L20.0132 6.67511C20.6301 6.3011 21 5.67808 21 5.01106ZM21 19H14M20 17L22 19L20 21M11 17H4.25C3.00688 17 2 16.1041 2 14.998V6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
